
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ValuesHeroSection from './components/ValuesHeroSection';
import EthicsSection from './components/EthicsSection';

export default function Values() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ValuesHeroSection />
        <EthicsSection />
      </main>
      <Footer />
    </div>
  );
}
